import { Backdrop, alpha, styled } from '@mui/material';

export const BlendDown = styled(Backdrop)(({ theme }) => ({
    backgroundColor: alpha(theme.palette.common.white, 0.4),
    zIndex: theme.zIndex.drawer + 1,
}));
